'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _experiumPlayerWebLegacy = require('experium-player-web-legacy');

Object.defineProperty(exports, 'Controls', {
    enumerable: true,
    get: function get() {
        return _experiumPlayerWebLegacy.Controls;
    }
});
Object.defineProperty(exports, 'Container', {
    enumerable: true,
    get: function get() {
        return _experiumPlayerWebLegacy.Container;
    }
});
Object.defineProperty(exports, 'textComponents', {
    enumerable: true,
    get: function get() {
        return _experiumPlayerWebLegacy.textComponents;
    }
});
Object.defineProperty(exports, 'formComponents', {
    enumerable: true,
    get: function get() {
        return _experiumPlayerWebLegacy.formComponents;
    }
});
Object.defineProperty(exports, 'textComponent', {
    enumerable: true,
    get: function get() {
        return _experiumPlayerWebLegacy.textComponent;
    }
});
Object.defineProperty(exports, 'validate', {
    enumerable: true,
    get: function get() {
        return _experiumPlayerWebLegacy.validate;
    }
});